import { NgModule, Component, OnInit, ViewChild, Input } from '@angular/core';
import { ADMIN_ROLES } from '../../../../enums';
import { UserDataApi } from '../../../../../assets/js/lb-sdk';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';

interface AdminForm {
  id: string,
  adminType: string,
  firstName: string,
  lastName?: string,
  middleName?: string,
  extensionName?: string,
  email: string,
  contactNumber?: string,
  username: string,
  usercode: string,
  retypeUsercode: string
}

@Component({
  selector: 'app-admin-registration',
  templateUrl: './admin-registration.component.html',
  styleUrls: ['./admin-registration.component.css']
})
export class AdminRegistrationComponent implements OnInit {
  created: boolean;
  usernameUsed: boolean;
  error: string;
  loading: boolean = false;
  ADMIN_ROLES: typeof ADMIN_ROLES = ADMIN_ROLES;
  REGEX = {
    USERNAME: /^[a-zA-Z]+[a-zA-Z0-9_]*$/,
    USERCODE: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)])[A-Za-z\d$@$!%*?&#;:<>,.`~_\-\+\[\]\\\\/\|\{\}\'\"\=\^\(\)]{8,}$/
  };
  @ViewChild('adminUserForm') public adminUserForm: NgForm;
  @Input('data') public data: AdminForm;

  constructor(
    private userDataApi: UserDataApi
  ) { }

  ngOnInit() {}

  submit(form) {
    if (form.valid) {
      this.created = false;
      const {
        id,
        adminType,
        firstName,
        lastName,
        middleName,
        extensionName,
        email,
        contactNumber,
        username,
        usercode
      } = this.data;
      this.error = undefined;
      this.loading = true;
      this.userDataApi
        .matchUsername(username)
        .subscribe(
          hasMatch => {
            if (hasMatch.response) {
              this.usernameUsed = true;
              this.loading = false;
            } else {
              this.usernameUsed = false;
              (id ?
                this.userDataApi
                  .patchAttributes(id, {
                    firstName,
                    lastName,
                    middleName,
                    extensionName,
                    contactNumber
                  }) :
                this.userDataApi
                  .create({
                    username,
                    password: usercode,
                    firstName,
                    lastName,
                    middleName,
                    extensionName,
                    contactNumber,
                    email,
                    adminType
                  })
              ).pipe(finalize(() => {
                this.loading = false;
              }))
              .subscribe(
                response => {
                  this.created = true;
                },
                error => {
                  if (error && error.message) {
                    this.error = error.message.split('The `UserData` instance is not valid. ').join('');
                  } else {
                    this.error = 'Failed to create user.';
                  }
                }
              );
            }
          },
          error => {
            this.error = 'Failed to verify username match.';
          }
        );
    }
  }
}

